/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const CGUPage = () => {
  return (
    <div className='min-h-screen bg-gray-100 p-6 flex flex-col items-center'>
      <section
        id='cgu-voyo'
        style={{
          fontFamily: 'Arial, sans-serif',
          maxWidth: '800px',
          margin: '0 auto',
          padding: '20px',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <h1
          className='bird'
          style={{
            textAlign: 'center',
            color: '#E94E3D',
            fontSize: '2em',
            marginBottom: '20px',
          }}
        >
          🐦 Conditions Générales d'Utilisation (CGU) – Voyo
        </h1>
        <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '30px' }}>
          Bienvenue sur <strong>Voyo</strong> ! Simplifiez la recherche de logement en déléguant vos
          visites à des visiteurs de confiance.
        </p>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐤 1. Création de compte et sécurité
        </h2>
        <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
          <li>
            Créez un <strong>seul compte</strong> avec des informations exactes.
          </li>
          <li>
            Gardez votre <strong>mot de passe confidentiel</strong> et surveillez toute activité sur
            votre compte.
          </li>
          <li>Signalez immédiatement tout usage non autorisé.</li>
        </ul>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦜 2. Comportement attendu
        </h2>
        <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
          <li>
            Respectez les autres utilisateurs : pas de contenu offensant, violent, harcelant ou
            illégal.
          </li>
          <li>Ne pas usurper l'identité d'autrui ou promouvoir des services concurrents.</li>
          <li>Ne perturbez pas le fonctionnement de la plateforme.</li>
        </ul>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐦 3. Contenu publié
        </h2>
        <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
          <li>Les photos, commentaires et avis doivent vous appartenir ou être autorisés.</li>
          <li>Vous autorisez Voyo à utiliser ce contenu pour le service et sa promotion.</li>
        </ul>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🕊 4. Responsabilités
        </h2>
        <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
          <li>
            Voyo met en relation mandants et visiteurs, mais
            <strong>n&apos;effectue pas les visites directement</strong>.
          </li>
          <li>Chaque utilisateur est responsable de ses décisions et interactions.</li>
          <li>Voyo n'est pas responsable des dommages ou litiges liés aux visites.</li>
        </ul>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦢 5. Suspension ou résiliation
        </h2>
        <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
          <li>Voyo peut suspendre ou résilier un compte en cas de non-respect des CGU.</li>
          <li>Vous pouvez supprimer votre compte à tout moment depuis votre espace personnel.</li>
        </ul>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐥 6. Données et confidentialité
        </h2>
        <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
          <li>
            Vos informations sont traitées selon notre
            <a href='/politique-confidentialite' style={{ color: '#E94E3D' }}>
              Politique de confidentialité
            </a>
            .
          </li>
          <li>
            Vous acceptez la collecte et l'utilisation de vos données pour le fonctionnement et la
            communication de Voyo.
          </li>
        </ul>

        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦚 7. Acceptation
        </h2>
        <p style={{ marginBottom: '20px' }}>
          En utilisant Voyo, vous confirmez avoir lu et compris ces conditions. Si vous n'acceptez
          pas ces CGU, <strong>merci de ne pas utiliser la plateforme</strong>.
        </p>
      </section>

      <style>{`
        /* Animation oiseaux */
        .bird {
          display: inline-block;
          transform-origin: center bottom;
          transition: transform 0.4s ease;
        }

        .bird:hover {
          transform: translateY(-5px) rotate(-5deg);
        }

        /* Légère oscillation continue */
        @keyframes fly {
          0% { transform: translateY(0px) rotate(0deg); }
          25% { transform: translateY(-3px) rotate(-2deg); }
          50% { transform: translateY(0px) rotate(0deg); }
          75% { transform: translateY(-3px) rotate(2deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }

        .bird {
          animation: fly 4s ease-in-out infinite;
        }
      `}</style>
    </div>
  )
}

export default CGUPage
